import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

type CardProps = PropsWithChildren<{
  clickable?: boolean;
  onClick?: () => void;
}>;

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (props, ref) => {
    const { children, clickable, onClick } = props;
    const classNames = cn('card', { clickable });

    return (
      <div ref={ref} className={classNames} onClick={onClick}>
        {children}
      </div>
    );
  }
);

export const CardHeader = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => {
  return (
    <div ref={ref} className="card-header">
      {props.children}
    </div>
  );
});

export const CardTitle = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => {
  return (
    <div ref={ref} className="card-title">
      {props.children}
    </div>
  );
});

export const CardBlock = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => {
  return (
    <div ref={ref} className="card-block">
      {props.children}
    </div>
  );
});

export const CardText = React.forwardRef<HTMLDivElement, PropsWithChildren<{}>>(
  (props, ref) => {
    return (
      <div ref={ref} className="card-text">
        {props.children}
      </div>
    );
  }
);

export const CardFooter = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<{}>
>((props, ref) => {
  return (
    <div ref={ref} className="card-footer">
      {props.children}
    </div>
  );
});

type FooterActionProps = PropsWithChildren<{
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}>;

export const CardFooterAction = React.forwardRef<
  HTMLButtonElement,
  FooterActionProps
>((props, ref) => {
  const { children, onClick } = props;

  return (
    <button ref={ref} className="btn btn-sm btn-link" onClick={onClick}>
      {children}
    </button>
  );
});

interface ImageProps {
  src: string;
  alt?: string;
}

export const CardImage = React.forwardRef<HTMLDivElement, ImageProps>(
  (props, ref) => {
    const { src, alt } = props;
    return (
      <div ref={ref} className="card-img">
        <img src={src} alt={alt} />
      </div>
    );
  }
);
